<template>
  <div
    :style="[
      {
        margin: `${$smallAppBarHeight} ${$globalSideMargin} 0`,
        position: 'relative',
      },
      $breakpoints.mdAndUp && {
        margin: `${$getScaledCssValue('25px')} ${$globalSideMargin} 0`,
      },
    ]"
  >
    <img
      src=""
      :style="[
        // Values found with trial and error
        {
          position: 'absolute',
          opacity: 0.05,
          zIndex: 0,
          top: '52px',
          left: '50%',
          transform: 'translate(42%, 0)',
          display: 'block',
          objectFit: 'contain',
          height: 'calc(100% - 52px)',
        },
        $breakpoints.smAndDown && {
          height: '500px',
          opacity: 0.02,
          top: '200px',
          left: '100%',
          transform: 'translate(-30%, 0)',
        },
      ]"
    />

    <div
      :style="[
        {
          position: 'relative',
          gridTemplateColumns: `1fr`,
          maxWidth: $maxWidth,
          margin: '0 auto',
        },
        $breakpoints.mdAndUp && {
          display: 'grid',
          gridTemplateColumns: `${$getScaledCssValue('327px')} 1fr`,
        },
      ]"
    >
      <MediaSidebar
        v-if="showSidebar && $breakpoints.mdAndUp"
        class="mb-2"
        :style="{
          gridColumn: 'span 1',
          justifySelf: 'start',
          alignSelf: 'stretch',
          justifySelf: 'stretch',
        }"
        :sidebarData="sidebarData"
        @update:selectedSidebarItems="updateItems"
      />

      <div
        :class="{ 'd-flex flex-column align-stretch': $breakpoints.smAndDown }"
        :style="[
          {},
          $breakpoints.mdAndUp && {
            gridColumn: showSidebar ? 'span 1' : 'span 2',
            marginLeft: showSidebar ? $getScaledCssValue('24px') : null,
          },
        ]"
      >
        <!-- Form section -->
        <div
          class="rounded white"
          :style="[
            {
              boxShadow: `0 ${$getScaledCssValue('6px')} ${$getScaledCssValue(
                '20px'
              )} #AAAAAA65`,
              margin: `0 -${$globalSideMargin}`,
              padding: `0 ${$globalSideMargin} 16px`,
              position: 'relative',
            },
            $breakpoints.mdAndUp && {
              margin: 0,
              padding: `${$getScaledCssValue('36px')} ${$getScaledCssValue(
                '54px'
              )}`,
              position: 'static',
            },
          ]"
        >
          <!-- Hides box shadow at the top -->
          <div
            v-if="$breakpoints.smAndDown"
            :style="{
              position: 'absolute',
              top: '-30px',
              left: '0',
              width: '100%',
              height: '30px',
              backgroundColor: 'white',
            }"
          />
          <slot name="searchForm">
            <form @submit.prevent="$emit('formSubmitted')">
              <div class="d-flex flex-column">
                <SearchInput
                  :style="{
                    marginBottom: $getScaledCssValue('22px'),
                  }"
                  style="outline: none !important; padding-block: 1em"
                  id="searchInput"
                  :value="searchTerm"
                  @input="$emit('update:searchTerm', $event)"
                />

                <div
                  :class="{
                    'd-flex justify-space-between': true,
                    'flex-column': $breakpoints.smAndDown,
                  }"
                >
                  <div class="d-flex" :style="{ flexGrow: '1' }">
                    <slot name="searchDropdowns" />
                  </div>

                  <div :class="{ 'align-self-center': $breakpoints.smAndDown }">
                    <SearchButton @click="$emit('formSubmitted')" />
                  </div>
                </div>
              </div>
            </form>
          </slot>

          <!-- Active filters -->
          <div class="mt-2 d-flex flex-wrap">
            <slot name="activeFilters" />
          </div>
        </div>

        <!-- Small screen filter area -->
        <div
          v-if="$breakpoints.smAndDown"
          class="d-flex justify-center"
          :style="{
            position: 'relative',
            zIndex: '2',
            margin: `0 -${$globalSideMargin}`,
          }"
        >
          <div
            class="secondary"
            :style="{
              padding: '8px 24px 16px',
              borderRadius: '0 0 32px 32px',
              position: 'relative',
              zIndex: '2',
              cursor: 'pointer',
            }"
            @click="smallScreenFiltersOpen = !smallScreenFiltersOpen"
          >
            <Arrow
              :class="smallScreenFiltersOpen ? 'up' : 'down'"
              borderWidth="2px"
              width="8px"
              :style="{
                borderColor: 'white',
                transition: 'transform 300ms ease-in-out',
              }"
            />
          </div>
          <div
            :style="{
              position: 'absolute',
              left: 0,
              top: 0,
              width: '100%',
              transition:
                'transform 300ms ease-in-out, opacity 300ms ease-in-out',
              transform: `scaleY(${smallScreenFiltersOpen ? '1' : '0'})`,
              opacity: smallScreenFiltersOpen ? 1 : 0,
              transformOrigin: 'top center',
            }"
          >
            <MediaSidebar
              :sidebarData="sidebarData"
              @update:selectedSidebarItems="updateItems"
            />
          </div>
        </div>

        <!-- List items -->
        <div
          :style="{
            overflowY: 'scroll',
            overflowX: 'visible',
            scrollbarWidth: 'none',
            //maxHeight: $getScaledCssValue('747px'),
            padding: `${$getScaledCssValue('18px')} ${$getScaledCssValue(
              '20px'
            )} 0`,
            margin: `2px ${$getScaledCssValue('-20px')}`,
            position: 'relative',
          }"
        >
          <div
            class="list-items-container"
            :style="{
              position: 'relative',
            }"
          >
            <slot name="listItems" />
          </div>
        </div>
      </div>

      <Pagination
        v-if="itemObjects && itemObjects.length > 0"
        :currentPage="currentPage"
        :totalPages="totalPages"
        @input="$emit('update:currentPage', $event)"
        :style="[
          { margin: '40px 0' },
          $breakpoints.mdAndUp && {
            margin: `${$getScaledCssValue('50px')} 0 ${$getScaledCssValue(
              '50px'
            )} ${$getScaledCssValue('24px')}`,
            gridColumn: showSidebar ? '2 / 3' : 'span 2',
          },
        ]"
      />
    </div>
  </div>
</template>
  
  <script>
import MediaItem from "./MediaItem.vue";
import Pagination from "../../Utils/Pagination.vue";
import MediaSidebar from "../../Utils/MediaSidebar.vue";
import SearchInput from "../../Utils/SearchInput.vue";
import SearchDropdown from "../../Utils/SearchDropdown.vue";
import SearchButton from "../../Utils/SearchButton.vue";
import { LoremIpsum } from "lorem-ipsum";
import TextField from "../../inputs/TextField.vue";
import Arrow from "../../Utils/Arrow.vue";
import TransitionHeight from "../../Utils/TransitionHeight.vue";

const lorem = new LoremIpsum({
  sentencesPerParagraph: {
    max: 8,
    min: 4,
  },
  wordsPerSentence: {
    max: 16,
    min: 4,
  },
});

export default {
  components: {
    MediaItem,
    TextField,
    Pagination,
    MediaSidebar,
    SearchInput,
    SearchDropdown,
    SearchButton,
    // ViewMapButton,
    Arrow,
    TransitionHeight,
  },
  props: {
    subject: {
      type: String,
    },

    itemObjects: {
      default: null,
    },

    selectedItemTypes: {
      default: null,
    },

    totalPages: {
      type: Number,
      default: 5,
    },

    currentPage: {
      type: Number,
    },

    listData: {
      type: Array,
      default: null,
    },

    searchTerm: {
      type: String,
      default: "",
    },

    countries: {
      type: Array,
      default: null,
    },

    showViewMapButton: {
      type: Boolean,
      default: true,
    },

    showSidebar: {
      type: Boolean,
    },

    sidebarData: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    filterData: {},
    smallScreenFiltersOpen: false,
  }),

  methods: {
    updateItems(selectedItems) {
      console.log("list section data:");
      console.log(selectedItems);
      this.$emit("update:selectedSidebarItems", selectedItems);
    },
  },
};
</script>
  
  <style scoped>
.search-area {
  background-color: #f5f5f5;
}

.search-button {
  margin-bottom: 30px;
}
#searchInput:focus {
  outline: none !important;
  background-color: red;
}
</style>
  